import * as React from 'react';
import cx from 'classnames';

export interface CKSelectListItemProps {
  isHighlighted: boolean;
  isSelected: boolean;
  isDisabled: boolean;
  isMultiSelect?: boolean;
  accessoryRenderer?: React.ReactChildren;
  itemMetaRenderer?: React.ReactChildren;
}

export const CKSelectListItem: React.FC<CKSelectListItemProps> = React.forwardRef(
  (
    {
      children,
      isHighlighted,
      isSelected,
      isDisabled,
      isMultiSelect,
      itemMetaRenderer,
      accessoryRenderer,
      ...rest
    },
    ref: React.Ref<HTMLLIElement>
  ) => {
    const listItemClass = cx('ck-option-item', {
      'ck-option-item--highlighted': isHighlighted,
      'ck-option-item--selected': isSelected && !isMultiSelect,
      'font-medium': isSelected && isMultiSelect,
      'ck-option-item--disabled': isDisabled,
    });

    return (
      <li className={listItemClass} {...rest} ref={ref}>
        {accessoryRenderer && (
          <span
            className="ck-option-item-accessory"
            style={{ pointerEvents: 'none' }}
          >
            {accessoryRenderer}
          </span>
        )}
        <span className="ck-option-value" style={{ userSelect: 'none' }}>
          {children}
        </span>
        {itemMetaRenderer && (
          <span className="ck-option-item-meta" style={{ userSelect: 'none' }}>
            {itemMetaRenderer}
          </span>
        )}
      </li>
    );
  }
);
